import React from 'react';
import DoctorDashboard from "../views/doctor/DoctorDashboard";
import AdminDashboard from "../views/admin/AdminDashboard";
import Patient from "../views/doctor/Patient";
import PatientVisit from "../views/doctor/PatientVisit";

const EditPatientComponent = ({isNested: isNested = false, props}) => <PatientVisit isNested={isNested} {...props}/>
/*
const PatientFormComponent = ({isNested: isNested = false, props}) => <PatientForm isNested={isNested} {...props}/>
*/
const HCPDashboardComponent = ({isNested: isNested = false, props}) => <DoctorDashboard isNested={isNested} {...props}/>
const PatientComponent = ({isNested: isNested = false, props}) => <Patient isNested={isNested} {...props}/>
const AdminDashboardComponent = ({isNested: isNested = false, props}) => <AdminDashboard isNested={isNested} {...props}/>



export {
/*
    PatientFormComponent,
*/
    HCPDashboardComponent,
    PatientComponent,
    EditPatientComponent,
    AdminDashboardComponent
}
